<template>
    <div v-if="!appData.enableConfigTrial && !appData.enableConfigOption">
        <div class="object-titlebox">
            <div class="object-titlebox-left" v-t="'message.title_app_restriction1'"></div>
        </div>
        <div class="object-inner-table">
            <table width=100%>
                <td width=50% class="object-item" v-t="'message.info_need_purchase_option'">
                </td>
            </table>
        </div>
    </div>
    <div v-else>
        <div class="object-titlebox">
            <div v-if="selectedNode.data.type == 0">
                <div class="object-titlebox-left" v-t="'message.title_app_restriction1'"></div>
            </div>
            <div v-else>
                <div class="object-titlebox-left" v-t="{ path: 'message.title_app_restriction2', args: { restriction: selectedNode.data.label } }"></div>
            </div>
            <div v-if="selectedNode.data.type != 0" class="object-titlebox-right">
                <div v-if="restrictUserList.length == 0">
                    <button class="transparent" type="button" v-on:click="onShowEditUserPrivilege"><img src="../assets/add_user.svg"/><span class="normal-command-text" v-t="'message.action_add_restriction_to_user'"></span></button>
                </div>
                <div v-else>
                    <button class="transparent" type="button" v-on:click="onShowEditUserPrivilege"><img src="../assets/edit.svg"/><span class="normal-command-text" v-t="'message.action_edit_restriction_of_user'"></span></button>
                </div>
            </div>
        </div>
        <div v-if="selectedNode.data.type == 0">
            <div class="object-inner-table">
                <table width=100%>
                    <tr width="100%" class="no-data-message">
                        <td style="display: inline-block" v-t="'message.info_select_app_restriction'">
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <div v-else>
            <div class="object-titlebox">
                <div class="object-titlebox-left">
                    <el-form @submit.native.prevent="submit">
                        <el-input :placeholder="$t('message.place_holder_input_text')" v-model.trim="searchKeyword" class="input-with-select" clearable  @clear="getInfo(0)" :disabled="userSearchDisabled" >
                            <el-select v-model="condition" slot="prepend" :placeholder="$t('message.place_holder_search_condition')">
                                <el-option :label="$t('message.item_userId')" value="name"></el-option>
                                <el-option :label="$t('message.item_userDisplayName')" value="displayName"></el-option>
                                <el-option :label="$t('message.item_organization')" value="organization"></el-option>
                                <el-option :label="$t('message.item_job_title')" value="title"></el-option>
                            </el-select>
                            <el-button slot="append" @click="getInfo(1)" style="width: 100px; vertical-align: middle;" native-type="submit" v-t="'message.action_filter_items'"></el-button>
                        </el-input>
                    </el-form>
                </div>
            </div>
            <div class="object-inner-table">
                <table width=100%>
                    <tr class="item-list-title">
                        <td width=50% class="object-item">
                            <div class="object-userlist-left">
                                <div class="object-userlist-right">
                                    <span class="item-list-header" v-t="'message.common_action_delete'"></span>
                                </div>
                                <span class="item-list-header" v-t="'message.item_userId_displayName'"></span>
                            </div>
                        </td>
                    </tr>
                    <tr width="100%" v-if="restrictUserList.length == 0" class="no-data-message">
                        <div v-if="searchKeyword == null">
                            <td style="display: inline-block" v-t="{ path: 'message.info_user_not_found_with_restriction', args: { restriction: selectedNode.data.label } }"></td>
                        </div>
                        <div v-else>
                            <td style="display: inline-block" v-t="'message.info_user_not_found'"></td>
                        </div>
                    </tr>
                    <tr v-for="(restrictUser,index) in restrictUserList" class="record-with-underline">
                        <td width=50% class="object-item">
                            <div class="object-userlist-left">
                                <div class="object-userlist-right">
                                    <button class="item-record-button" type="button" v-on:click="removeRestrictionConfirm(index)"><img class="icon-delete" src="../assets/icon_delete_user.svg" /></button>
                                </div>
                                {{ getUserDisplayName(restrictUser) }}
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <edituserprivileges v-if="showEditUserPrivilege" :appData="appData" :privilege="selectedNode.data.privilegeName" :editUserList="getRestrictUserList(selectedNode.data.privilegeName)" @save="saveUserRestrictions" @cancel="showEditUserPrivilege=false"></edituserprivileges>
        <confirmdeleteuser v-if="showConfirmDeleteUser" :confirmInfo="confirmInfo" @delete="removeRestriction" @cancel="showConfirmDeleteUser=false"></confirmdeleteuser>
    </div>
</template>

<script>
import Vue from 'vue'
import server from "./ServerApi.js";
import EditUserPrivileges from "./EditUserPrivileges.vue";
import DeleteObject from "./DeleteObject.vue";
import commonUtil from './commonutil.js';
import constants from './constants.js';

export default {
    data() {
      return {
            condition: "name",
            searchKeyword: null,
            showEditUserPrivilege: false,
            showConfirmDeleteUser: false,
            userSearchDisabled: true,
            restrictUserList: [],
            restrictLogoutUser: [],
            restrictPeerTalkUser: [],
            restrictMapTabUser: [],
            restrictChatTabUser: [],
            restrictChatSendUser: [],
            restrictSaveContents: [],
            restrictModifyName: [],
            confirmInfo: {
                objectName: null,
                objectTitle: null
            },
      };
    },
    methods: {
        onShowEditUserPrivilege() {
            if (!this.appData.tenantAdminUser) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_operate_no_tenantAdmin_privilege"));
                return;
            }

            this.showEditUserPrivilege = true
        },

        getInfo(getType) {
            let self = this;

            let param = { tenantId: this.appData.tenantList[0].tenantId, restriction: 1}
            if (getType == 0) {
                this.searchKeyword = null;
            } else {
                if (this.condition == "name") {
                    param.name = this.searchKeyword;
                } else if (this.condition == "displayName") {
                    param.displayName = this.searchKeyword;
                } else if (this.condition == "organization") {
                    param.organization = this.searchKeyword;
                } else if (this.condition == "title") {
                    param.title = this.searchKeyword;
                } else {
                    commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_search_condition_not_found"));
                    return;
                }
            }

            server.post('/finduser', param)
            .then((res) => {
                self.restrictLogoutUser = [];
                self.restrictPeerTalkUser = [];
                self.restrictMapTabUser = [];
                self.restrictChatTabUser = [];
                self.restrictChatSendUser = [];
                self.restrictSaveContents = [];
                self.restrictModifyName = [];
                switch(res.data.status) {
                    case 0:
                        for (let user of res.data.userInfo) {
                            if (commonUtil.checkUserPrivilege(user.restrictions, constants.RESTRICTION_LOGOUT)) {
                                self.restrictLogoutUser.push(user);
                            }
                            if (commonUtil.checkUserPrivilege(user.restrictions, constants.RESTRICTION_PEER_TO_PEER)) {
                                self.restrictPeerTalkUser.push(user);
                            }
                            if (commonUtil.checkUserPrivilege(user.restrictions, constants.RESTRICTION_MAP)
                                || commonUtil.checkUserPrivilege(user.restrictions, constants.RESTRICTION_MAP_TAB)) {
                                self.restrictMapTabUser.push(user);
                            }
                            if (commonUtil.checkUserPrivilege(user.restrictions, constants.RESTRICTION_CHAT_TAB)) {
                                self.restrictChatTabUser.push(user);
                            }
                            if (commonUtil.checkUserPrivilege(user.restrictions, constants.RESTRICTION_CHAT)
                                || commonUtil.checkUserPrivilege(user.restrictions, constants.RESTRICTION_CHAT_SEND)) {
                                self.restrictChatSendUser.push(user);
                            }
                            if (commonUtil.checkUserPrivilege(user.restrictions, constants.RESTRICTION_SAVE_CONTENTS)) {
                                self.restrictSaveContents.push(user);
                            }
                            if (commonUtil.checkUserPrivilege(user.restrictions, constants.RESTRICTION_MODIFY_NAME)) {
                                self.restrictModifyName.push(user);
                            }
                        }
                        break;
                    case -3:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_access_denied"));
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getInfo").replace("{code}",res.data.status));
                        break;
                }
                self.refreshRestrictUserList();
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "getInfo", error);
            });
        },
        saveUserRestrictions(input) {
            this.showEditUserPrivilege=false;
            let targetRestrictUserList;
            let privilegeName = this.selectedNode.data.privilegeName;
            switch(privilegeName) {
                case constants.RESTRICTION_LOGOUT:
                    targetRestrictUserList = this.restrictLogoutUser;
                    break;
                case constants.RESTRICTION_PEER_TO_PEER:
                    targetRestrictUserList = this.restrictPeerTalkUser;
                    break;
                case constants.RESTRICTION_MAP_TAB:
                    targetRestrictUserList = this.restrictMapTabUser;
                    break;
                case constants.RESTRICTION_CHAT_TAB:
                    targetRestrictUserList = this.restrictChatTabUser;
                    break;
                case constants.RESTRICTION_CHAT_SEND:
                    targetRestrictUserList = this.restrictChatSendUser;
                    break;
                case constants.RESTRICTION_SAVE_CONTENTS:
                    targetRestrictUserList = this.restrictSaveContents;
                    break;
                case constants.RESTRICTION_MODIFY_NAME:
                    targetRestrictUserList = this.restrictModifyName;
                    break;
            }

            let modifiedRestrictUserList = [];
            for (let userInfo of targetRestrictUserList) {
                modifiedRestrictUserList.push(userInfo);
            }

            let operations = [];
            for (let key in input.addTagList) {
                let tag = input.addTagList[key]
                if (tag.orgRestrictions == null) {
                    tag.orgRestrictions = "";
                }
                if (tag.orgRestrictions.indexOf(privilegeName) == -1) {
                    let newRestrictions;
                    if (tag.orgRestrictions != "") {
                        newRestrictions = tag.orgRestrictions + "," + privilegeName;
                    } else {
                        newRestrictions = privilegeName;
                    }
                    operations.push({
                        command: "modifyuser",
                        operation: {
                            tenantId: tag.tenantId,
                            name: tag.userName,
                            newRestrictions: newRestrictions,
                        }
                    })
                    modifiedRestrictUserList.push({
                       id: tag.userName,
                       name: tag.userName,
                       displayName: tag.displayName,
                       restrictions: newRestrictions
                   })
                }
            }

            for (let key in input.removeTagList) {
                let tag = input.removeTagList[key]
                if (tag.orgRestrictions == null) {
                    continue;
                }

                let restrictions = tag.orgRestrictions.split(",");
                let newRestrictions = this.getNewRemovedRestrictions(restrictions, privilegeName);
                if (newRestrictions == tag.orgRestrictions) {
                    continue;
                }

                operations.push({
                    command: "modifyuser",
                    operation: {
                        tenantId: tag.tenantId,
                        name: tag.userName,
                        newRestrictions: newRestrictions,
                    }
                })
                for (let i=0 ; i < modifiedRestrictUserList.length ; i++) {
                    if (modifiedRestrictUserList[i].name == tag.userName) {
                        modifiedRestrictUserList.splice(i,1);
                    }
                }
            }

            if (operations.length == 0) {
                return;
            }

            const loading = this.$loading({
                    lock: true ,
                    text: 'Updateing  Client restrictions ...' ,
                    spinner: 'el-icon-loading' ,
                    background: 'rgba(0, 0, 0, 0)'
            });
            let timer = setTimeout(() => {
                      loading.close();
                      commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"info_need_time_until_finish"));
                    }, 5000);

            let self = this;
            server.post('/multiop', {operations: operations})
                .then((res) => {
                    clearTimeout(timer);
                    loading.close();
                    switch(res.data.status) {
                        case 0:
                            commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_modify_app_restriction"));
                            this.refreshRestrictUserList();
                            this.getInfo(0);
                            break;
                        case constants.STATUS_ERROR_BATCH_PROCESS:
                            const isDeletedTenant = res.data.errorInfo.findIndex(data => data.errorCode === constants.STATUS_ERROR_TENANT_ALREADY_DELETED);
                            if (isDeletedTenant !== -1) {
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_tenant_already_deleted_unknown_details"));
                                break;
                            }
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_cannot_modify_restriction_by_denied"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","saveUserRestrictions").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "saveUserRestrictions", error);
                });
        },
        removeRestrictionConfirm(index) {
            if (!this.appData.tenantAdminUser) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_operate_no_tenantAdmin_privilege"));
                return;
            }

            this.removeRestrictionIndex = index;
            switch(this.selectedNode.data.privilegeName) {
                case constants.RESTRICTION_LOGOUT:
                    this.confirmInfo.objectTitle =  commonUtil.getMessageText(this.$i18n,"title_app_restriction2").replace("{restriction}",commonUtil.getMessageText(this.$i18n,"item_logout"));
                    break;
                case constants.RESTRICTION_PEER_TO_PEER:
                    this.confirmInfo.objectTitle =  commonUtil.getMessageText(this.$i18n,"title_app_restriction2").replace("{restriction}",commonUtil.getMessageText(this.$i18n,"item_individual_talk"));
                    break;
                case constants.RESTRICTION_MAP_TAB:
                    this.confirmInfo.objectTitle =  commonUtil.getMessageText(this.$i18n,"title_app_restriction2").replace("{restriction}",commonUtil.getMessageText(this.$i18n,"item_map_tab"));
                    break;
                case constants.RESTRICTION_CHAT_TAB:
                    this.confirmInfo.objectTitle =  commonUtil.getMessageText(this.$i18n,"title_app_restriction2").replace("{restriction}",commonUtil.getMessageText(this.$i18n,"item_chat_tab"));
                    break;
                case constants.RESTRICTION_CHAT_SEND:
                    this.confirmInfo.objectTitle =  commonUtil.getMessageText(this.$i18n,"title_app_restriction2").replace("{restriction}",commonUtil.getMessageText(this.$i18n,"item_chat_send"));
                    break;
                case constants.RESTRICTION_SAVE_CONTENTS:
                    this.confirmInfo.objectTitle =  commonUtil.getMessageText(this.$i18n,"title_app_restriction2").replace("{restriction}",commonUtil.getMessageText(this.$i18n,"item_save_contents"));
                    break;
                case constants.RESTRICTION_MODIFY_NAME:
                    this.confirmInfo.objectTitle =  commonUtil.getMessageText(this.$i18n,"title_app_restriction2").replace("{restriction}",commonUtil.getMessageText(this.$i18n,"item_modify_name"));
                    break;
            }
            this.confirmInfo.objectName = this.restrictUserList[this.removeRestrictionIndex].displayName;
            this.showConfirmDeleteUser = true;
        },
        removeRestriction() {
            this.showConfirmDeleteUser = false;
            let self = this;
            let restrictions = this.restrictUserList[this.removeRestrictionIndex].restrictions.split(",");
            let newRestrictions = this.getNewRemovedRestrictions(restrictions, this.selectedNode.data.privilegeName);
            if (newRestrictions == this.restrictUserList[this.removeRestrictionIndex].restrictions) {
                return;
            }

            server.post('/modifyuser', {
                    operation: {
                        tenantId: this.appData.tenantList[0].tenantId,
                        name: this.restrictUserList[this.removeRestrictionIndex].name,
                        newRestrictions: newRestrictions
                    }
                })
                .then((res) => {
                    switch(res.data.status) {
                        case 0:
                            commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_delete_restriction_from_user"));
                            self.getInfo(0);
                            break;
                        case constants.STATUS_ERROR_TENANT_ALREADY_DELETED:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_tenant_already_deleted_unknown_details"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","removeRestriction").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "removeRestriction", error);
                });
        },

        getNewRemovedRestrictions(restrictions, privilegeName) {
            let newRestrictions = "";
            for (let restriction of restrictions) {
                if (restriction != privilegeName) {
                    if (privilegeName == constants.RESTRICTION_MAP_TAB && restriction == constants.RESTRICTION_MAP) {
                        // 'map' is abolished
                        continue
                    }
                    if (privilegeName == constants.RESTRICTION_CHAT_SEND && restriction == constants.RESTRICTION_CHAT) {
                        // 'chat' is abolished
                        continue
                    }
                    if (newRestrictions != "") {
                        newRestrictions += ",";
                    }
                    newRestrictions += restriction ;
                }
            }
            return newRestrictions;
        },

        getRestrictUserList(privilege) {
            switch(privilege) {
                case constants.RESTRICTION_LOGOUT:
                    return this.restrictLogoutUser;
                case constants.RESTRICTION_PEER_TO_PEER:
                    return this.restrictPeerTalkUser;
                case constants.RESTRICTION_MAP_TAB:
                    return this.restrictMapTabUser;
                case constants.RESTRICTION_CHAT_TAB:
                    return this.restrictChatTabUser;
                case constants.RESTRICTION_CHAT_SEND:
                    return this.restrictChatSendUser;
                case constants.RESTRICTION_SAVE_CONTENTS:
                    return this.restrictSaveContents;
                case constants.RESTRICTION_MODIFY_NAME:
                    return this.restrictModifyName;
            }
        },
        getUserDisplayName(userInfo) {
            return userInfo.name + "@" +  this.appData.tenantList[0].name + " / " + userInfo.displayName;
        },
        refreshRestrictUserList() {
            switch(this.selectedNode.data.privilegeName) {
                case constants.RESTRICTION_LOGOUT:
                    this.restrictUserList = this.restrictLogoutUser;
                    break;
                case constants.RESTRICTION_PEER_TO_PEER:
                    this.restrictUserList = this.restrictPeerTalkUser;
                    break;
                case constants.RESTRICTION_MAP_TAB:
                    this.restrictUserList = this.restrictMapTabUser;
                    break;
                case constants.RESTRICTION_CHAT_TAB:
                    this.restrictUserList = this.restrictChatTabUser;
                    break;
                case constants.RESTRICTION_CHAT_SEND:
                    this.restrictUserList = this.restrictChatSendUser;
                    break;
                case constants.RESTRICTION_SAVE_CONTENTS:
                    this.restrictUserList = this.restrictSaveContents;
                    break;
                case constants.RESTRICTION_MODIFY_NAME:
                    this.restrictUserList = this.restrictModifyName;
                    break;
            }
            if (this.searchKeyword == null) {
                if (this.restrictUserList.length == 0) {
                    this.userSearchDisabled = true;
                } else {
                    this.userSearchDisabled = false;
                }
            }
        }
    },
    components: {
        edituserprivileges: EditUserPrivileges,
        confirmdeleteuser: DeleteObject,
    },
    created: function() {
        if (this.appData.tenantList.length > 0) {
            return this.getInfo(0);
        }
    },
    mounted: function() {
    },
    watch: {
        'appData.tenantList'(newVal) {
            this.getInfo(0);
        },
        'selectedNode'(newVal) {
            this.getInfo(0);
        }
    },
    props: [ 'appData' , 'selectedNode' ]
}

</script scoped>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.record-with-underline {
    border-bottom:1px #eee solid;
}

.input-with-select {
    width: 400px;
}
.input-with-select >>> .el-input-group__prepend {
    background-color: #fff;
}
.input-with-select >>> .el-select .el-input {
    font-size: 14px;
    width: 120px;
}
.input-with-select >>> .el-button {
    width: 40px;
    padding: 0;
}
.input-with-select >>> .el-input__inner {
    font-size: 14px;
    padding-left: 10px;
}
.el-select >>> .el-input__inner {
    font-size: 14px;
    padding-left: 10px;
}
.el-select-dropdown__item {
    font-size: 14px;
}

</style>
